import React from 'react'
import {
  makeStyles,
  Grid,
  LinearProgress,
  TextField,
  Button,
  Typography,
  CircularProgress,
  MenuItem,
} from '@material-ui/core'
import { useMutation } from '@apollo/react-hooks'
import { CREATE_USER } from './queries'
import { toast } from 'react-toastify'

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main
  },
  submit: {
    display: 'flex',
    margin: 'auto',
    maxWidth: 250,
    marginTop: 50,
    marginBottom: 250,
  }
}))

const TOTAL_FIELDS_REQUIRED = 3

export default function UserForm(props) {
  const classes = useStyles()
  const [progress, setProgress] = React.useState(0)
  const [name, setName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [role, setRole] = React.useState('')
  const [profile, setProfile] = React.useState('administrator')
  const [emailError, setEmailError] = React.useState('')
  const [createUser, { loading, error }] = useMutation(CREATE_USER, {
    onCompleted: () => {
      toast.success('Usuário criado com sucesso!')
      setName('')
      setEmail('')
      setRole('')
      setProfile('administrator')
    }
  })

  React.useEffect(() => {
    if (email) {
      let errorMessage = ''
      if (!email.match(/\w+@\w+\.\w+/)) errorMessage = 'O e-mail digitado está inválido'
      if (!email.includes('.'))         errorMessage = 'O e-mail precisa conter um .'
      if (!email.includes('@'))         errorMessage = 'O e-mail precisa conter um @'

      setEmailError(errorMessage)
    }
  }, [email])

  React.useEffect(() => {
    let totalFilled = 1

    if (!!name) totalFilled++
    if (!!email) totalFilled++

    setProgress(100 * totalFilled / TOTAL_FIELDS_REQUIRED)
  }, [name, email, profile])

  if (error) {
    toast.error(error.message)
  }

  const handleSubmit = () => {
    createUser({
      variables: {
        name,
        email,
        profile,
        role
      }
    })
  }

  return (
    <Grid container spacing={ 5 } justify="center">
      <Grid item xs={ 12 }>
        <Typography variant="h5" className={ classes.title }>
          Cadastrar Usuário
        </Typography>
      </Grid>

      <Grid item xs={ 12 }>
        <TextField
          label="Nome Completo *"
          fullWidth
          value={ name }
          onChange={ event => setName(event.target.value) }
        />
      </Grid>
      <Grid item xs={ 12 }>
        <TextField
          error={ !!emailError }
          helperText={ emailError }
          label="E-Mail *"
          fullWidth
          value={ email }
          onChange={ event => setEmail(event.target.value) }
        />
      </Grid>

      <Grid item xs={ 12 } md={ 6 }>
        <TextField
          select
          fullWidth
          value={ profile }
          onChange={ event => setProfile(event.target.value) }
          label="Perfil *"
        >
          <MenuItem value={ 'administrator' }>Administrador</MenuItem>
          <MenuItem value={ 'manager' }>Coordenador</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={ 12 } md={ 6 }>
        <TextField
          label="Responsável por"
          fullWidth
          value={ role }
          onChange={ event => setRole(event.target.value) }
        />
      </Grid>

      <Grid item xs={ 12 } justify="center">
        <LinearProgress
          variant="determinate"
          value={ progress }
        />
      </Grid>

      <Grid item xs={ 12 } md={ 4 }>
        <Button
          fullWidth
          className={ classes.submit }
          onClick={ handleSubmit }
          disabled={
            !name ||
            !email ||
            !!emailError
          }
        >
          {
            loading
              ? <CircularProgress size={ 25 } />
              : 'Criar Usuário'
          }
        </Button>
      </Grid>
    </Grid>
  )
}
